var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skill text-center"},[_c('font-awesome-icon',{staticStyle:{"margin":"0 .5rem","float":"left"},attrs:{"icon":_vm.icon}}),_c('span',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }